import { render, staticRenderFns } from "./YiLianSensitiveAuthorizationLetter.vue?vue&type=template&id=5a2afbc6&scoped=true"
import script from "./YiLianSensitiveAuthorizationLetter.vue?vue&type=script&lang=js"
export * from "./YiLianSensitiveAuthorizationLetter.vue?vue&type=script&lang=js"
import style0 from "./YiLianSensitiveAuthorizationLetter.vue?vue&type=style&index=0&id=5a2afbc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2afbc6",
  null
  
)

export default component.exports